import TrackingService from "./tracking_service.js";
import ComboPromoButton from "./combopromo_button.js";
import "../scss/all.scss";
import { defineEvent } from "@otto-ec/global-resources/nexus";
import {promoComboPresentation} from "@otto-ec/nexus-registry/promo/combo/presentation";

window.otto.ft3bcn.combopromo.assignNamespace({
    updateButton: defineEvent()
});

promoComboPresentation.assignNamespace({
    imageChange: defineEvent(),
    variationChange: defineEvent(),
});

window.o_p13n_combopromo = window.o_p13n_combopromo || {};
window.o_p13n_combopromo.api = new ComboPromoButton();
window.o_p13n_combopromo.tracking = new TrackingService();
